import Class from '@core/Class';
import Module from '@core/Module';
import appLogger from '@core/LoggingProvider';
import {Cart} from './Cart';
import Modal from '@plugins/modal';
import {noCookieDialog} from '@util/HtmlComponents';
import ProductCatalogService from '@services/ProductCatalogService';

const CartQuickAddItem = Class.extend( Module ).extend( {
    elements: {
        '.addToCart': 'addButton',
        '.itemActions input': 'qtyInput',
        '.itemActions': 'itemActions'
    },

    events: {
        'click addButton': '_handleAdd',
        'keypress addButton': '_handleAdd',
        'keyup qtyInput': '_handleAdd',
        'change qtyInput': '_handleQtyChange',
        'quickadd:process': '_processing'
    },

    init: function () {
        this._onAddFailed = this._onAddFailed.bind( this );

        this.ready( function () {
            // remove existing DOM0 onclick event attached to .addToCart buttons
            if ( this.addButton.length ) {
                this.originalHandler = this.addButton[0].onclick;
                this.addButton[0].onclick = null;
            }
        } );
    },
    _handleQtyChange: function ( e ) {
        this.addButton.focus();
    },

    _handleAdd: function ( e ) {
        if ( this.isProcessing ) {
            return;
        }
        if ( (e.type === 'keyup' || e.type === 'keypress') && e.keyCode !== 13 ) {
            return;
        }

        var qty = Math.max( 1, this.qtyInput.val() );

        this._processing( true );

        this._getSkuInfo()
            .then( product => {
                if ( !product ) {
                    return this._onAddFailed( new Error( `Product not found` ) );
                }

                e.preventDefault();

                this.addItem( product, qty ).then( () => this._processing( false ) );
            } )
            .catch( this._onAddFailed )
    },

    _onAddFailed ( err ) {
        appLogger.capture( err );
        console.warn( 'CartQuickAddItem Failed:', err.message );
        this._processing( false );
        if ( typeof this.originalHandler == 'function' ) {
            this.originalHandler()
        }
        return err;
    },

    /**
     * Get SKU string from input field
     * @param id
     * @returns {null}
     * @private
     */
    _getSkuDataFromInput ( input ) {
        const id = input.attr( 'id' ).match( /quantity_(.*)$/i );
        return (id && id.length) ? id[1] : null;
    },

    _getSkuInfo: function () {
        const sku =
            this.addButton.attr( 'item' )
            || this.addButton.attr( 'data-item-id' )
            || this._getSkuDataFromInput( this.qtyInput ); // last resort: pluck from qty field id attr

        return ProductCatalogService.getDetail( sku );
    },

    addItem: function ( product, quantity ) {
        if ( !navigator.cookieEnabled ) {
            Modal.getInstance().open( {content: noCookieDialog, width: 560} );
            return false;
        }

        const itemAdditions = [{product, quantity}];
        // returns a promise
        return Cart
            .add_to_cart( itemAdditions )
            .then( cart => {
                console.log( '[Returned cart]:', cart );
                Cart.trigger( 'quickadd:item', {...cart, itemAdditions} )
            } )
            .catch( this._onAddFailed )
    },

    _processing: function ( isProcessing ) {
        this.isProcessing = isProcessing;
        this.addButton.toggleClass( 'processing', isProcessing );
    }
} );

export default CartQuickAddItem;
